// extracted by mini-css-extract-plugin
export default {"root":"DayListNavigationBar-module_root_a7aaa6"};